(function () {
  if (window.RRVisibleCollectionFiltersInitialized) return;
  window.RRVisibleCollectionFiltersInitialized = true;

  var activeController = null;
  var requestSequence = 0;

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  function reactivateScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function setLoading(isLoading) {
    var visibleFilters = document.querySelector('.rr-visible-filters');
    if (!visibleFilters) return;
    visibleFilters.classList.toggle('is-loading', isLoading);
    if (isLoading) {
      visibleFilters.setAttribute('aria-busy', 'true');
    } else {
      visibleFilters.removeAttribute('aria-busy');
    }
  }

  function announce(message) {
    var status = document.querySelector('[data-rr-visible-filter-status]');
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 50);
  }

  function revealTypeLink(link) {
    if (!link) return;
    var row = link.closest('.rr-visible-types');
    var linkBounds = link.getBoundingClientRect();
    var rowBounds = row.getBoundingClientRect();
    if (linkBounds.left < rowBounds.left + 8) {
      row.scrollLeft += linkBounds.left - rowBounds.left - 8;
    } else if (linkBounds.right > rowBounds.right - 8) {
      row.scrollLeft += linkBounds.right - rowBounds.right + 8;
    }
  }

  function restoreScroll(left, top) {
    window.requestAnimationFrame(function () {
      window.scrollTo(left, top);
      window.requestAnimationFrame(function () {
        window.scrollTo(left, top);
      });
    });
  }

  function applyFilter(url, options) {
    options = options || {};
    var currentVisibleFilters = document.querySelector('.rr-visible-filters');
    var currentCollection = document.querySelector('[data-rr-collection-results]');
    if (!currentVisibleFilters || !currentCollection) {
      window.location.assign(url.toString());
      return;
    }

    if (activeController) activeController.abort();
    activeController = new AbortController();
    requestSequence += 1;
    var thisRequest = requestSequence;
    var scrollLeft = window.scrollX;
    var scrollTop = window.scrollY;

    setLoading(true);

    fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'fetch' },
      signal: activeController.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed');
        return response.text();
      })
      .then(function (html) {
        if (thisRequest !== requestSequence) return;

        var nextDocument = new DOMParser().parseFromString(html, 'text/html');
        var nextVisibleFilters = nextDocument.querySelector('.rr-visible-filters');
        var nextCollection = nextDocument.querySelector('[data-rr-collection-results]');
        if (!nextVisibleFilters || !nextCollection) {
          throw new Error('Filtered collection markup was not found');
        }

        currentVisibleFilters.replaceWith(nextVisibleFilters);
        currentCollection.replaceWith(nextCollection);
        revealTypeLink(nextVisibleFilters.querySelector('.rr-visible-type.is-active'));
        reactivateScripts(nextCollection);

        if (options.updateHistory !== false) {
          window.history.pushState(
            { rrCollectionFilter: true },
            '',
            url.pathname + url.search
          );
        }

        restoreScroll(scrollLeft, scrollTop);
        announce('Products updated');
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.assign(url.toString());
      })
      .finally(function () {
        if (thisRequest === requestSequence) {
          activeController = null;
          setLoading(false);
        }
      });
  }

  document.addEventListener('focusin', function (event) {
    var link = event.target.closest('.rr-visible-types .rr-visible-type');
    revealTypeLink(link);
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('.rr-visible-filters a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

    var url;
    if (link.dataset.rrFilterGroup === 'type') {
      url = new URL(window.location.href);
      var typeParam = link.dataset.rrFilterParam;
      var typeValue = link.dataset.rrFilterValue;
      var typeIsActive = link.dataset.rrFilterActive === 'true';

      if (typeParam) {
        url.searchParams.delete(typeParam);
        url.searchParams.delete('page');
        if (typeValue && !typeIsActive) {
          url.searchParams.append(typeParam, typeValue);
        }
      }
    } else {
      url = new URL(link.href, window.location.href);
    }
    if (url.origin !== window.location.origin) return;

    event.preventDefault();
    url.hash = '';
    applyFilter(url);
  });

  window.addEventListener('popstate', function () {
    var url = new URL(window.location.href);
    url.hash = '';
    applyFilter(url, { updateHistory: false });
  });

  revealTypeLink(document.querySelector('.rr-visible-type.is-active'));
  window.addEventListener('load', function () {
    revealTypeLink(document.querySelector('.rr-visible-type.is-active'));
  }, { once: true });
})();
